module.exports = __webpack_public_path__ + "img/chinesecompany28.ba881e7b.png";